<template>
    <div>
        <div class="col-sm-12 row" v-if="$gate.isAdmin() || $gate.isReception() || $gate.isManager() || $gate.isSupervisor()">
            <div v-for="(setting, index) in settings" :key="index">
                <div class="col-md-12">
                    <input type="text" class="form-control" v-model="setting.currency" />
                </div>
                <div class="col-md-12">
                    <input type="number" class="form-control" v-model="setting.tax" />
                </div>
                <div class="col-md-12">
                    <input type="number" class="form-control" v-model="setting.drawer" />
                </div>
                <div class="col-md-12 row mt-2 ml-2">
                    <label> Xero:
                    <input type="radio" value="true" class="ml-2" v-model="setting.xero" /> True </label>
                    <label>
                    <input type="radio" value="false" class="ml-2" v-model="setting.xero" /> False </label>
                </div>
                <div class="col-md-12 row mt-2 ml-2">
                    <label> Email:
                    <input type="radio" value="true" class="ml-2" v-model="setting.email" /> True </label>
                    <label>
                    <input type="radio" value="false" class="ml-2" v-model="setting.email" /> False </label>
                </div>
                <div class="col-md-12">
                    <button class="btn btn-success" @click="save(setting)"><i class="fa fa-save"></i></button>
                </div>
            </div>

        </div>
        <div class="col-sm-12 row" v-else>
            <notfound></notfound>
        </div>
    </div>
</template>
<script>
import Swal from 'sweetalert2'
    window.Swal = Swal
    const toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
    });
export default {
    data() {
        return {
            settings: [],
        }
    },
    created() {
        this.getSettings()
    },
    methods: {
        getSettings() {
            axios
            .get('./api/Setting')
            .then((result) => {
                console.log(result)
                this.settings = result.data
            }).catch((err) => {
                console.log(err)
            });
        },
        save(setting) {
            axios
            .post('./api/Setting/Save', {
                currency: setting.currency,
                tax: setting.tax,
                drawer: setting.drawer,
                xero: setting.xero,
                email: setting.email
            })
            .then((result) => {
                console.log(result)
            }).catch((err) => {
                console.log(err)
            });
            toast({
                type: 'success',
                title: 'Settings successfully updated'
                })
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/Others/Settings/settings.vue